import Vue from "vue";
import Vuetify from "vuetify/lib";
import pt from "vuetify/es5/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  lang: {
    locales: { pt },
    current: "pt"
  },
  theme: {
    themes: {
      light: {
        primary: "#F36784"
      }
    }
  }
});
